import * as React from 'react';
import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material';

import { BaseComponentProps } from '../types';

export interface FullscreenProps extends BaseComponentProps {
  centered?: boolean;
  children?: React.ReactNode;
  disableScroll?: boolean;
  layout?: 'vertical' | 'horizontal';
  color?: MuiBoxProps['color'];
  backgroundColor?: MuiBoxProps['bgcolor'];
  sx?: MuiBoxProps['sx'];
}

export const Fullscreen = ({
  centered,
  backgroundColor = 'background.default',
  color = 'text.primary',
  layout = 'vertical',
  disableScroll = true,
  children,
  sx,
}: FullscreenProps) => (
  <MuiBox
    color={color}
    bgcolor={backgroundColor}
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: disableScroll ? 'hidden' : 'auto',
      display: 'flex',
      flexDirection: layout === 'vertical' ? 'column' : 'row',
      alignItems: centered ? 'center' : undefined,
      justifyContent: centered ? 'center' : undefined,
      ...sx,
    }}
  >
    {children}
  </MuiBox>
);
